// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customInput[data-v-9ac7a0ee]{\n  border-radius: 10px;\n  height: 42px;\n  border:0.5px solid rgba(168, 174, 184, 0.5);\n}\n.customFormInput[data-v-9ac7a0ee] {\n  height: 34px !important;\n  max-height: 34px !important;\n}\n.customFormInput[data-v-9ac7a0ee]:hover {\n  background-color: rgba(242, 183, 5, 0.1);\n  border: 0.5px solid rgba(168, 174, 184, 0.5);\n  height: 34px !important;\n}\n", ""]);
// Exports
module.exports = exports;
